import React, { useContext } from "react";
import LiquidGauge from "react-liquid-gauge";
import {
  Box,
  Card,
  Chip,
  Grid,
  Stack,
  Typography,
  Divider,
} from "@mui/material";
import {
  LocalShipping as DeliveryIcon,
  Science as LeakIcon,
  WarningAmber as AlarmIcon,
} from "@mui/icons-material";
import clienteAxios from "../../config/axios";
import AlertaContext from "../../Context/Alerta/AlertaContext";

const PRODUCTO_INFO = {
  "3": { color: "#FFD700", label: "DIESEL", codigo: 59, nombreCompleto: "DIESEL PREMIUM" },
  "2": { color: "#00BFFF", label: "EXTRA", codigo: 57, nombreCompleto: "GASOLINA EXTRA" },
  "1": { color: "#708090", label: "SUPER", codigo: 58, nombreCompleto: "GASOLINA SUPER" },
};
const DEFAULT_PRODUCTO = { color: "#A9A9A9", label: "DESCONOCIDO", codigo: null, nombreCompleto: "DESCONOCIDO" };

const getProductoInfo = (productoCode) =>
  PRODUCTO_INFO[String(productoCode)] || DEFAULT_PRODUCTO;

const getTotalesTanque = async (codigoCombustible) => {
  try {
    // Realizar la solicitud al endpoint
    const response = await clienteAxios.get(
      "/abastecimientos/totales_anual_mensual_semanal_diara"
    );
    console.log({ response, codigoCombustible });

    const totales = response.data;

    const totalDiario = totales.total_diario.filter(
      (item) => item.codigoCombustible === codigoCombustible
    );
    const totalSemanal = totales.total_semanal.filter(
      (item) => item.codigoCombustible === codigoCombustible
    );
    const totalMensual = totales.total_mensual.filter(
      (item) => item.codigoCombustible === codigoCombustible
    );
    const totalAnual = totales.total_anual.filter(
      (item) => item.codigoCombustible === codigoCombustible
    );

    // Verificar si hay datos para el código de combustible
    if (
      totalDiario.length === 0 &&
      totalSemanal.length === 0 &&
      totalMensual.length === 0 &&
      totalAnual.length === 0
    ) {
      return {
        error: true,
      };
    }

    // Retornar los datos filtrados
    return {
      totalDiario,
      totalSemanal,
      totalMensual,
      totalAnual,
    };
  } catch (error) {
    console.error("Error al obtener los totales del tanque:", error.message);
    return {
      error: true,
      totalDiario: [],
      totalSemanal: [],
      totalMensual: [],
      totalAnual: [],
    };
  }
};
export const Liquid = ({ tanque, setdataTotales }) => {
  const {
    tanque: numeroTanque,
    producto_code: productoCode,
    volumen,
    vacio,
    temperatura,
    agua,
    volumen_agua: volumenAgua = 0,
    altura = 0,
    tc_volumen: tcVolumen = null,
    status_hex: statusHex = "",
    delivery_in_progress: deliveryInProgress = false,
    leak_test_in_progress: leakTestInProgress = false,
    invalid_fuel_height_alarm: fuelAlarm = false,
    timestamp_dispositivo: timestampDispositivo,
  } = tanque;

  const { mostrarAlerta } = useContext(AlertaContext);
  const volumenTotal = volumen + vacio;
  const porcentajeLlenado = ((volumen / volumenTotal) * 100).toFixed(2);

  const producto = getProductoInfo(productoCode);
  const color = producto.color;
  const tanqueLabel = producto.label;
  const codigoTotales = producto.codigo;

  return (
    <Grid item xs={12} sm={6} md={4}>
      <Card
        elevation={5}
        sx={{
          padding: "1rem",
          borderRadius: "15px",
          backgroundColor: "#ffffff",
          position: "relative",
          overflow: "hidden",
          cursor: "pointer",
        }}
        onClick={async () => {
          if (!codigoTotales) {
            return mostrarAlerta(
              "No se pudo identificar el producto del tanque",
              "error",
            );
          }

          const res = await getTotalesTanque(String(codigoTotales));
          if (res.error) {
            return mostrarAlerta(
              "Hubo un error al obtener los datos del tanque",
              "error"
            );
          }

          setdataTotales({
            ...res,
            nombreCombustible: producto.nombreCompleto,
          });
        }}
      >
        {/* Indicador circular con opacidad */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%) scale(0.8)", // Escalado para ajustar tamaño
            opacity: 0.2, // Opacidad para el fondo
            zIndex: 1,
          }}
        >
          <LiquidGauge
            value={porcentajeLlenado}
            radius={60}
            textSize={1}
            textRenderer={() => null} // Ocultar el texto del medidor
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={3}
            gradient
            gradientStops={[
              { key: "0%", stopColor: color, stopOpacity: 1, offset: "0%" },
              {
                key: "100%",
                stopColor: color,
                stopOpacity: 0.8,
                offset: "100%",
              },
            ]}
            circleStyle={{
              fill: color,
            }}
            waveStyle={{
              fill: color,
            }}
          />
        </Box>

        {/* Contenido encima del fondo */}
        <Box
          sx={{
            position: "relative",
            zIndex: 2, // Asegurar que el contenido esté encima del fondo
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#000",
              }}
            >
              {porcentajeLlenado}%
            </Typography>
          </Box>
          {/* Información del tanque */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.75,
              marginBottom: "0.25rem",
            }}
          >
            <Typography variant="h6" align="center">
              {tanqueLabel}
            </Typography>
            <Chip
              label={`TQ ${numeroTanque}`}
              size="small"
              sx={{
                height: 20,
                fontSize: "0.7rem",
                fontWeight: 700,
                backgroundColor: color,
                color: "#000",
              }}
            />
          </Box>

          {(fuelAlarm || deliveryInProgress || leakTestInProgress) && (
            <Stack
              direction="row"
              spacing={0.5}
              sx={{ marginBottom: "0.5rem", flexWrap: "wrap", gap: 0.5 }}
            >
              {fuelAlarm && (
                <Chip
                  icon={<AlarmIcon sx={{ fontSize: 16 }} />}
                  label="Alarma nivel"
                  size="small"
                  color="error"
                  variant="filled"
                  sx={{ height: 22, fontSize: "0.7rem", fontWeight: 600 }}
                />
              )}
              {deliveryInProgress && (
                <Chip
                  icon={<DeliveryIcon sx={{ fontSize: 16 }} />}
                  label="Descarga"
                  size="small"
                  color="info"
                  variant="filled"
                  sx={{ height: 22, fontSize: "0.7rem", fontWeight: 600 }}
                />
              )}
              {leakTestInProgress && (
                <Chip
                  icon={<LeakIcon sx={{ fontSize: 16 }} />}
                  label="Test fuga"
                  size="small"
                  color="secondary"
                  variant="filled"
                  sx={{ height: 22, fontSize: "0.7rem", fontWeight: 600 }}
                />
              )}
            </Stack>
          )}

          <Divider sx={{ marginY: "0.5rem" }} />
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Volumen Actual:</strong>
            </Typography>
            <Typography variant="body2">{volumen.toFixed(2)} G</Typography>
          </Box>
          {tcVolumen !== null && (
            <Box
              display="flex"
              justifyContent="space-between"
              marginBottom="0.5rem"
            >
              <Typography variant="body2" color="text.secondary">
                <strong>Vol. Comp. Temp:</strong>
              </Typography>
              <Typography variant="body2">{tcVolumen.toFixed(2)} G</Typography>
            </Box>
          )}
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Volumen Vacío:</strong>
            </Typography>
            <Typography variant="body2">{vacio.toFixed(2)} G</Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Altura:</strong>
            </Typography>
            <Typography variant="body2">{altura.toFixed(2)} mm</Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Temperatura:</strong>
            </Typography>
            <Typography variant="body2">{temperatura.toFixed(2)} °C</Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Agua (altura):</strong>
            </Typography>
            <Typography variant="body2">{agua.toFixed(2)} mm</Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Agua (volumen):</strong>
            </Typography>
            <Typography variant="body2">{volumenAgua.toFixed(2)} G</Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            marginBottom="0.5rem"
          >
            <Typography variant="body2" color="text.secondary">
              <strong>Capacidad:</strong>
            </Typography>
            <Typography variant="body2">
              {(volumen + vacio).toFixed(2)} G
            </Typography>
          </Box>{" "}
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              <strong>Estado:</strong>
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {statusHex || "—"}
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              <strong>Fecha:</strong>
            </Typography>
            <Typography variant="body2">
              {new Date(timestampDispositivo).toLocaleString("es-ES", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Typography>
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};
